<template>
    <section class="course-section spad pt-0 pb-0">
        <div class="course-warp">
            <div class="featured-courses pt-3">
                <div class="featured-course course-item">
                    <div class="course-thumb set-bg" :style="{ 'background-image': 'url(' + course.image + ')' }">
                    </div>
                    <div class="row m-0">
                        <div class="col-lg-6 offset-lg-6 p-0">
                            <div class="course-info">
                                <div class="course-details row m-0 text-secondary text-uppercase">
                                    <div class="col">
                                        <font-awesome-icon class="mr-1" icon="signal"  /> {{ course.level.name }}
                                    </div>
                                    <div class="col">
                                        <font-awesome-icon class="mr-1" icon="music"  /> {{ course.category.name}}
                                    </div>
                                </div>
                                <div class="course-text">	
                                    <p class="h3 text-left title">{{ course.title }}</p>
                                    <p class="h6 text-muted text-left icon"><font-awesome-icon class="mr-1" icon="clock"  /> {{ course.duration }} min</p>
                                    <p class="h6 text-left description">{{ course.description_long }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'course-detail',
    props: ['course'] 
}
</script>

<style lang="scss" scoped>
@import "@/variables.scss";

.course-section {
    .course-info {
        .course-details {
            border-bottom: 1px solid #d4dee1;
            padding: 14px 33px;
            overflow: hidden;
            svg {
                color: $main-color;
            }
        }
        .course-text {
            padding: 40px !important;
            padding-top: 30px !important;
            .icon {
                font-size: 0.95em;
                margin-bottom: 15px;
                svg {
                    color: $main-color;
                }
            } 
            .description {
                line-height: 1.8em;
            }
        }
    }
    .set-bg {
        background-position: center;
    }
}
</style>


